import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

import {BootstrapVue, IconsPlugin} from 'bootstrap-vue';

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import VueMoment from 'vue-moment';
Vue.use(VueMoment);

import VueMask from 'v-mask'
Vue.use(VueMask, {
    placeholders: {
        'Z': /^[a-zA-Z0-9\-_!#$%&'*+/=?`{|}~^.-@]+/ // valid email char
    }
})

import VueQuill from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
Vue.use(VueQuill);

import Notifications from '@/components/Notification';
Vue.use(Notifications);

import OtpInput from "@bachdgvn/vue-otp-input";
Vue.component("v-otp-input", OtpInput);

Vue.prototype.$http = axios;
const token = localStorage.getItem('token');
if (token) {
    console.log('Setting token.');
    axios.defaults.headers.common['Authorization'] = token;
}

import axios from 'axios';

axios.interceptors.response.use(function (response) {
    return response;
}, function (err) {
    if (err.response.status === 401) {
        // console.log('Received 401, signing out.');
        store.dispatch('signOut');
        if (router.currentRoute.path !== '/login') router.push('/login');
    }
    return Promise.reject(err);
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

Vue.filter('currency', function (value) {
    if (typeof value !== "number") {
        return value;
    }
    var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    });
    return formatter.format(value);
});

Vue.filter('tel', function (phone) {
    if (phone) {
        return phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    } else {
        return 'N/A';
    }
});

Vue.filter('capitalize', function (value) {
    if (value) {
        return value.toLowerCase().replace(/(?:^|\s|-)\S/g, x => x.toUpperCase());
    } else {
        return '';
    }
});

Vue.filter('formatSize', function (num) {
    // jacked from: https://github.com/sindresorhus/pretty-bytes
    if (typeof num !== 'number' || isNaN(num)) {
        throw new TypeError('Expected a number');
    }

    var exponent;
    var unit;
    var neg = num < 0;
    var units = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    if (neg) {
        num = -num;
    }

    if (num < 1) {
        return (neg ? '-' : '') + num + ' B';
    }

    exponent = Math.min(Math.floor(Math.log(num) / Math.log(1000)), units.length - 1);
    num = (num / Math.pow(1000, exponent)).toFixed(2) * 1;
    unit = units[exponent];

    return (neg ? '-' : '') + num + ' ' + unit;
});
